import HttpService from "../../services/HttpService";

class Rating {
    id: number;
    rating: number;
}

async function getGoogleRating(branchCodeName: string): Promise<Rating> {
    try {
        const result = await HttpService.get<Rating>(`${process.env.GATSBY_API_URL}/branches/googleRating?`,
            null,
            {
                params: {
                    branchCodeName: branchCodeName
                }
            });

        return result;
    } catch (e) {
        console.error(`There is an error retrieving branch ${branchCodeName} google rating`);
        return null;
    }
}

export default {
    getGoogleRating
}